import {
    EventOrganizerSelfOnboardingStepType,
    SelfOnboardingStepType,
} from "~graphql/generated/types"

// Every step after the three required outfitter steps (info, addresses, description) can be skipped
const SKIPPABLE_STEP_TYPES: string[] = [
    SelfOnboardingStepType.OutfitterPhotosV2,
    SelfOnboardingStepType.OutfitterCheckInSettingsV2,
    SelfOnboardingStepType.OutfitterCancellationV2,
    SelfOnboardingStepType.PaymentsStripeV2,
    SelfOnboardingStepType.PaymentsDepositSettingsV2,
    SelfOnboardingStepType.ListingDetailsV2,
    SelfOnboardingStepType.ListingDescriptionV2,
    SelfOnboardingStepType.ListingLodgingV2,
    SelfOnboardingStepType.ListingAddOnsV2,
    SelfOnboardingStepType.ListingPackagesV2,
    SelfOnboardingStepType.ListingAvailabilityV2,
]

export function isSelfOnboardingStep(
    step?: string
): step is SelfOnboardingStepType {
    if (!step) {
        return false
    }

    return Object.values<string>(SelfOnboardingStepType).includes(step)
}

export function isSkippableSelfOnboardingStep(step?: string) {
    if (!step) return false

    return SKIPPABLE_STEP_TYPES.includes(step)
}

export function isEventOrganizerSelfOnboardingStep(
    step?: string
): step is EventOrganizerSelfOnboardingStepType {
    if (!step) return false

    return Object.values<string>(EventOrganizerSelfOnboardingStepType).includes(
        step
    )
}
